import { render, staticRenderFns } from "./DebtorData.vue?vue&type=template&id=6b33f695&"
import script from "./DebtorData.vue?vue&type=script&lang=js&"
export * from "./DebtorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports